import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@lib/components/base';
import { AngularMaterialModule } from '../../../../material.module';
import { SpinnerComponent } from '@lib/components';

interface IEntity {
    name: string;
    value: string;
}
@Component({
    standalone: true,
    selector: 'app-modal-change-customer-status',
    templateUrl: './card-status-modal.component.html',
    styleUrls: ['./card-status-modal.component.scss'],
    imports: [AngularMaterialModule, SpinnerComponent],
})
export class CardStatusModalComponent extends BaseComponent {
    protected statusItems: Array<IEntity>;
    public constructor(@Inject(MAT_DIALOG_DATA) public status: string, public dialogRef: MatDialogRef<CardStatusModalComponent>) {
        super();
        this.statusItems = this.validateDropdownCardStatus();
    }

    protected validateDropdownCardStatus(): Array<IEntity> {
        switch (this.status) {
            case 'ACTIVE':
                return [
                    { name: 'SUSPENDED', value: 'SUSPEND' },
                ];
            case 'SUSPENDED':
            case 'INACTIVE':
                return [
                    { name: 'ACTIVE', value: 'ACTIVATE' },
                ];
        }
        return [];
    }

    protected closeModal(status: string) {
        this.dialogRef.close(status);
    }
}
